import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DateCalendar } from '@mui/x-date-pickers/DateCalendar';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import dayjs, { Dayjs } from 'dayjs';
import { useStore } from 'src/context/StoreContext';
import DayOfWeekFormatter from '../../calendar/dateCalendar/DayOfWeekFormatter';
import { jaJP } from '@mui/x-date-pickers/locales';
import CustomCalendarHeader from './CustomCalendarHeader';

// const initialValue = dayjs();
type DateCalendarCustomProps = {
    onChangeDate: (date: Dayjs | null) => void,
    initialValue: string
};
const CalendarPicker: React.FC<DateCalendarCustomProps> = (props) => {
  const storeContext = useStore();
  const store = storeContext.store;

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} localeText={jaJP.components.MuiLocalizationProvider.defaultProps.localeText}>
      <DateCalendar
        defaultValue={dayjs(props.initialValue)}
        value={dayjs(props.initialValue)}
        onChange={(newValue) => {
            props.onChangeDate(newValue);
        }}
        showDaysOutsideCurrentMonth
        views={['day']}
        dayOfWeekFormatter={DayOfWeekFormatter}
        sx={{
          '& .MuiBadge-root .Mui-selected, & .MuiBadge-root .Mui-selected:hover, & .MuiBadge-root .Mui-selected:focus':
            {
              bgcolor: 'red',
            },
          backgroundColor: store.palette.calendar.bgColor,
        }}
        slots={{ calendarHeader: CustomCalendarHeader }} 
      />
    </LocalizationProvider>
  );
};

export default CalendarPicker;
